import { render, staticRenderFns } from "./paymentButtons.vue?vue&type=template&id=53388b4a&scoped=true&"
import script from "./paymentButtons.vue?vue&type=script&lang=js&"
export * from "./paymentButtons.vue?vue&type=script&lang=js&"
import style0 from "./paymentButtons.vue?vue&type=style&index=0&id=53388b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53388b4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTextarea,VTooltip})
